<template>
    <card>
        <template slot="header">
            <h3 class="card-title">{{ title }}</h3>
            <p class="card-category"></p>
        </template>
        <div class="row">
            <div class="col-md-6">
                <div class="table-responsive">
                    <table class="table chart-legend-table">
                        <tbody>
                            <tr>
                                <td><strong>Name</strong></td>
                                <td class="text-right"><strong>Total</strong></td>
                            </tr>
                            <tr v-for="(item, index) in items" :key="index" v-bind:class="{'has-total': (index == items.length - 1 && hasTotal)}">
                                <td>{{$t(item.title)}}</td>
                                <td class="text-right">{{item.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 bpf-chart-holder">
                <pie-chart :chart-data="computedChartData" :extra-options="chartOptions"></pie-chart>
            </div>
        </div>
        <!-- <div class="row mt-5">
            <div class="col-12">
                <base-button @click="exportExcell()" type="default" size="lg" class="btn-fill">
                    Export
                </base-button>
            </div>
        </div> -->
    </card>
</template>
<script>
import PieChart from "src/components/Charts/PieChart.js";

export default {
    name: "chart-card",
    components:
    {
        PieChart
    },
    props:
    {
        chartData: Object,
        items: Array,
        title: String,
        hasTotal:
        {
            type: Boolean,
            default: true,
        }
    },
    data()
    {
        return {
            chartOptions:
            {
                legend:
                {
                    display: false
                }
            }
        };
    },
    computed:
    {
        computedChartData: function ()
        {
            const vm = this;
            let labels = [];
            let data = [];

            if (vm.items)
            {
                labels = vm.items.map(function (item)
                {
                    return vm.$t(item.title);
                }).filter(function (item)
                {
                    return item !== 'Total';
                });

                data = vm.items.filter(function (item)
                {
                    return item.title !== 'Total';
                }).map(function (item)
                {
                    return item.value;
                });
            }

            return {
                datasets:
                [
                    {
                        backgroundColor: ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff', '#4E0013', '#74132C', '#003925', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4', '#d8eb67', '#a05195', '#d45087', '#ffa600', '#FF5733'],
                        data: data
                    }
                ],
                labels: labels
            };
        }
    },
    mounted()
    {
    },
    methods:
    {

    }
};
</script>
<style lang="scss">
    .bpf-chart-holder
    {
        display: flex;
        justify-content: center;
    }

    #pie-chart
    {
        /* width: 80% !important;
        height: auto !important; */
        margin: auto;
    }

    .chart-legend-table tbody tr
    {
        td:first-child
        {
            position: relative;
            padding-left: 37px;
        }

        td:first-child:before
        {
            content: '';
            // position: relative;
            // top: 4px;
            position: absolute;
            top: 12px;
            left: 7px;
            // position: absolute;
            // top: 0;
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 10px;

            // background-color: #ff6384;
        }

        &:nth-child(2) td:first-child:before { background-color: #ff6384; }
        &:nth-child(3) td:first-child:before { background-color: #ffcd56; }
        &:nth-child(4) td:first-child:before { background-color: #36a2eb; }
        &:nth-child(5) td:first-child:before { background-color: #8ceb36; }
        &:nth-child(6) td:first-child:before { background-color: #6393ff; }
        &:nth-child(7) td:first-child:before { background-color: #9863ff; }
        &:nth-child(8) td:first-child:before { background-color: #4E0013; }
        &:nth-child(9) td:first-child:before { background-color: #74132C; }
        &:nth-child(10) td:first-child:before { background-color: #003925; }
        &:nth-child(11) td:first-child:before { background-color: #267257; }
        &:nth-child(12) td:first-child:before { background-color: #0E553C; }
        &:nth-child(13) td:first-child:before { background-color: #b0b6f2; }
        &:nth-child(14) td:first-child:before { background-color: #c8bef3; }
        &:nth-child(15) td:first-child:before { background-color: #dbc7f3; }
        &:nth-child(16) td:first-child:before { background-color: #ebd2f4; }
        &:nth-child(17) td:first-child:before { background-color:  #d8eb67; }
        &:nth-child(18) td:first-child:before { background-color:  #a05195; }
        &:nth-child(19) td:first-child:before { background-color:  #d45087; }
        &:nth-child(20) td:first-child:before { background-color:  #ffa600; }
        &:nth-child(21) td:first-child:before { background-color:  #FF5733; }
    }

    .chart-legend-table tbody tr.has-total td:first-child
    {
        font-weight: bold;

        &:before
        {
            display: none;
        }
    }
</style>
